(() => {
  const describe = (data, requested, now = Date.now()) => {
    if (!Number.isSafeInteger(requested) || requested < 1) return ['Enter a valid quantity', 'Choose a whole number of units to check availability.'];
    if (!data?.id) return ['This combination is unavailable.', ''];
    const lead = data.approved && data.leadTime ? `Estimated lead time: ${data.leadTime}.` : data.supplierLeadTime ? `Estimated ready to ship: ${data.supplierLeadTime} from order confirmation.` : 'Contact us for the estimated lead time.';
    if (data.hold) return ['Available to order — dispatch needs confirmation', `Confirm availability and dispatch timing for all ${requested} before ordering.`];
    if (!data.available) {
      if (data.discontinued === false) return ['Temporarily sold out — not discontinued.', 'Restocks generally take 1–6 weeks.'];
      return ['Currently unavailable', '', false];
    }
    if (!data.tracked || !Number.isFinite(Date.parse(data.validUntil)) || Date.parse(data.validUntil) <= now || !Number.isSafeInteger(data.stock) || data.stock < 0) {
      return [data.specialOrder && data.approved ? 'Special order' : 'Confirm availability', 'Contact us to confirm availability and lead time for your selected quantity.'];
    }
    const ready = Math.min(requested, data.stock);
    if (ready === requested) return ['Available, ready to ship', '', false];
    return [`${ready} available now`, `Remaining ${requested - ready}: ${lead}`];
  };
  if (typeof module !== 'undefined') module.exports = { describe };
  if (typeof document === 'undefined' || window.ihQuantityAvailabilityInitialized) return;
  window.ihQuantityAvailabilityInitialized = true;
  const update = () => document.querySelectorAll('[data-product-availability]').forEach(element => {
    const source = element.querySelector('[data-quantity-stock]');
    if (!source) return;
    let data; try { data = JSON.parse(source.textContent); } catch { return; }
    const input = element.closest('product-info')?.querySelector('input[name="quantity"]');
    const messages = describe(data, Number(input ? input.value : 1));
    element.hidden = messages[0] === 'Available, ready to ship';
    const root=element.closest('product-info');if(root)root.dataset.draftSoldOut=String(data.available === false);
    const link=element.querySelector('[data-quantity-contact] a');
    const contactText=!data.available && data.discontinued === false ? 'Contact us for restock timing or to place a preorder.' : 'Confirm availability and timing';
    if(link && link.textContent!==contactText)link.textContent=contactText;

    ['[data-quantity-heading]', '[data-quantity-detail]'].forEach((selector, i) => {
      const node = element.querySelector(selector);
      if (node && node.textContent !== messages[i]) node.textContent = messages[i];
      if (node) { node.hidden = !messages[i]; node.style.display = messages[i] ? '' : 'none'; }
    });
    const contact = element.querySelector('[data-quantity-contact]');
    if (contact) { contact.hidden = messages[2] === false; contact.style.display = contact.hidden ? 'none' : ''; }
  });
  const initialize = () => {
    update();
    new MutationObserver(records => {
      if (records.some(record => record.target.matches?.('[data-quantity-stock]') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-quantity-stock]') || node.querySelector('[data-quantity-stock]'))))) update();
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(update, 10000); // Withdraw ready claims when the inventory snapshot expires.
  };
  document.addEventListener('input', event => { if (event.target.matches('product-info input[name="quantity"]')) update(); });
  document.addEventListener('change', event => {
    if (event.target.matches('product-info input[name="quantity"]')) {
      update();
      window.InspireEngagement?.track('product-availability', 'quantity_check', 'requested-quantity');
    }
  });
  document.addEventListener('product-info:loaded', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
})();
